import { gql, TypedDocumentNode } from '@common/hooks';
import { SpearfishingCampaignFragment as SpearfishingCampaignFragmentType } from '@common/graphql/schema';

export type SpearfishingMessageType =
  | 'home_unit'
  | 'individuals'
  | 'workforce_groups';

export const SpearfishingCampaignFragment: TypedDocumentNode<SpearfishingCampaignFragmentType> = gql`
  fragment SpearfishingCampaign on SpearfishingCampaign {
    id
    messageType
    createdAt
    createdBy {
      id
      worksUser {
        id
        name
      }
    }
    shiftGap {
      id
      startDatetime
      endDatetime
      timeZone
      shiftDuration
      timeOfDay
      organizationUnit {
        id
        name
        costCenter
      }
      organizationBusiness {
        id
        name
      }
      role {
        id
        abbreviation
        name
      }
      openShiftGapOpenings {
        id
      }
    }
    spearfishingNotifications {
      id
    }
  }
`;
